import config from '@/config';
import { replaceJsonBuffers } from './helpers';

export type StorageKey = 'wallet-map' | 'templates' | 'locale' | 'hide-wallet-disclaimer-map';

const getKey = (key: StorageKey) => `${config.projectTitle.toLocaleLowerCase()}_${key}`;

export const setToLocalStorage = (data: unknown, key: StorageKey) => {
  const processed = typeof data === 'string' ? data : JSON.stringify(data);
  localStorage.setItem(getKey(key), processed);
};

export const getFromLocalStorage = <T>(key: StorageKey): T | null => {
  const data = localStorage.getItem(getKey(key));

  let parsed;
  try {
    parsed = data ? JSON.parse(data) : null;
  } catch (err) {
    parsed = data;
  }

  return replaceJsonBuffers(parsed);
};

export const setToSessionStorage = (data: unknown, key: StorageKey) => {
  const processed = typeof data === 'string' ? data : JSON.stringify(data);
  sessionStorage.setItem(getKey(key), processed);
};

export const getFromSessionStorage = <T>(key: StorageKey): T | null => {
  const data = sessionStorage.getItem(getKey(key));

  let parsed;
  try {
    parsed = data ? JSON.parse(data) : null;
  } catch (err) {
    parsed = data;
  }

  return replaceJsonBuffers(parsed);
};

export const getFromLocalStorageUnsafe = <T>(key: StorageKey): T | null => {
  const data = localStorage.getItem(getKey(key));

  let parsed;
  try {
    parsed = data ? JSON.parse(data) : null;
  } catch (err) {
    parsed = data;
  }

  return parsed;
};

export const removeItemFromStorage = (key: StorageKey) => {
  localStorage.removeItem(getKey(key));
};
